@if (!initialized) {
<ft-loading></ft-loading>
}
<mat-sidenav-container id="ft-wrapper" class="app-container">
  <mat-sidenav [opened]='!noNavBar && sideBarState.leftSideBarOpen === true' class="ft-sidebar-wrap hidden-print" #snav [mode]="mobileQuery.matches ? 'over' : 'side'">
    @if (initialized && !noNavBar) {
    <div class="sidebar-content">
      <div class="sidebar-header">
        <button
          type="button"
          mat-icon-button
          class="sidebar-close-btn"
          (click)="toggleSideNav()"
          aria-label="Close sidebar"
          title="Close sidebar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <ft-menu (menuSelect)="onMenuSelect()"></ft-menu>
    </div>
    }
  </mat-sidenav>

  <mat-sidenav-content id="ft-sidenav-content">
    <div class="app-shell">
      @if (initialized && !noNavBar && !fullWindow && !hideTopBar) {
      <div id="ft-navbar-wrap">
        <mat-toolbar class="ft-navbar" color="primary">
          <mat-toolbar-row class="flex-mat-toolbar-row toolbar-row-main">
            <div class="ft-nav-buttons">
              <button type="button" id="top-bar-menu-btn" mat-icon-button (click)="toggleSideNav()" aria-label="Menu" title="Menu">
                <mat-icon>menu</mat-icon></button>
              <button type="button" id="top-bar-home-btn" mat-icon-button (click)="changeState()" aria-label="Home" title="Home">
                @if (!homeButtonImage) {
                <mat-icon>home</mat-icon>
                }
                @if (homeButtonImage) {
                <img class="homeButtonImage" [src]="(fileResources ?
                          (fileResources.base64strData || fileResources.url) : null)"/>
                }
              </button>
            </div>
            <div class="nav-spacer"></div>

            <div class="ft-nav-search" id="navigationSearch">
              @if (hideGeneralSearch === false) {
              <ft-search-box search="true"></ft-search-box>
              }
            </div>

            <div class="ft-offline-status">
              @if (!user.publicAccount && !isCachingNotAllowed) {
              <ft-offline-status></ft-offline-status>
              }
            </div>
            @if (enableDarkMode) {
            <div class="ft-theme-toggle">
              <app-theme-toggle></app-theme-toggle>
            </div>
            }
            <div class="ft-user">
              <ft-user></ft-user>
            </div>
            @if (docInfo.imageLink.imageFileNo96) {
            <picture class="docHeader img-print-position">
              <img (click)="viewImageFile()" class="img-responsive img-thumbnail" [src]="(fileResourcesCommandBar ?
                (fileResourcesCommandBar.base64strData || fileResourcesCommandBar.url) : null)"
                onerror="this.src='images/ft-uploader/ft-uploader-default-gallery-placeholder.png';"/>
            </picture>
            }

          </mat-toolbar-row>

          <mat-toolbar-row class="toolbar-row-sub" [style]="dynamicCSSObj.commandBarCSS">
            <ft-command-bar></ft-command-bar>
          </mat-toolbar-row>

        </mat-toolbar>
      </div>
      }

      <div class="app-content" cdkScrollable>
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
